export enum DataHubBaseActions {
  Click = 'click',
  Close = 'close',
  Select = 'select',
  Try = 'try',
  View = 'view'
}
